export class TcListFilterModel {
  [type: string]: any;
}
